import { Box, Paper, Typography, Tabs, Tab, Container } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { useState } from "react";
import PersonalDetails from "./PersonalDetails";
import Address from "./Address";
import BankDetails from "./BankDetails";
import Documents from "./Documents";
// import Alert from '@mui/material/Alert'; 
import { useDispatch } from "react-redux";
import { clearError, setError } from '../../../../Redux/action-creators/errorAction';
import { clearSuccessMessage, setSuccessMessage } from "../../../../Redux/action-creators/successAction";
import { fetchLastMISPId, insertMispProfileDetails } from '../../api/mispService'
import { documentsUpload } from "../../../posp/functions/upload-doc";


 
const SignUp = () => {
 
    const [count, setCount] = useState(0)
    const [personalData, setPersonalData] = useState({})
    const [addressData, setAddressData] = useState({})
    const [bankData, setBankData] = useState({})
    const [documentsData, setDocumentsData] = useState({})
 
    const [isLoaderTrue, setIsLoaderTrue] = useState(false)
    const navigate = useNavigate();
    const dispatch = useDispatch();
   
 
    // upload files to s3
    const uploadFiles = async (files) => {
        const uploadedData ={}
        try{
 
            for (let key in files) {
                if (files[key] !== null){
                    const response = await documentsUpload(files[key], 'MISP SIGNUP' , 'upload')
                    uploadedData[key] = response
                }else{
                    uploadedData[key] = null
                }
               
            }
            return uploadedData
 
        }catch(e){ 
            console.error('Error uploading files:', e.message);
        }
 
       
    };

    const generateMisptId = (previesMispId) =>{
        const misp_id = parseInt(previesMispId.slice(7, previesMispId.length)) + 1
        const first_part = previesMispId.slice(0, previesMispId.length - (misp_id).toString().length)
        return (first_part + misp_id)
 
    }
 
 
    const callPostApi = async (documentData) => {
        dispatch(clearError());
        dispatch(clearSuccessMessage());
        setIsLoaderTrue(true)
 
        try{
            
            const filesUrl = await uploadFiles(documentData)

            if (Object.keys(filesUrl).length === Object.keys(documentData).length){
                // const agent_code = 'LMVPOS000000' // call api
                let newMisptId
                const Misp_code = await fetchLastMISPId()
                if (Misp_code?.data?.length === 0){
                    newMisptId = 'LMVMISP000000'
                }else{
                    newMisptId = generateMisptId(Misp_code?.data)
                }
                 
                const farmateMispDetails = {
                    org_id: 100,
                    MISP_id: newMisptId,
                    channel_partner_name: personalData?.channel_partner_name,
                    type_of_dealer: personalData?.type_of_dealer,
                    dealer_pan_number: personalData?.dealer_pan_number,
                    dealer_gst_number: personalData?.Dealer_gst_number,
                    dealer_principal_firstname: personalData?.dealer_principal_firstname,
                    dealer_principal_lastname: personalData?.dealer_principal_lastname,
                    dealer_principal_phone_number: personalData?.dealer_principal_phone_number,
                    dealer_principal_email_id:  personalData?.dealer_principal_email_id,
                    dealer_principal_KYC: personalData?.dealer_principal_KYC,
                    sales_person_firstname: personalData?.sales_person_firstname,
                    sales_person_lastname: personalData?.sales_person_lastname,
                    sales_person_mobile_number: personalData?.sales_person_phone_number,
                    sales_person_email_id: personalData?.sales_person_email_id,
                    sales_person_KYC: personalData?.sales_person_KYC,
                    sales_person_educational_certificate: personalData?.sales_person_educationalDetails,
                    address: addressData?.address_line,
                    landmark: addressData?.land_mark,
                    pincode: addressData?.pincode,
                    city: addressData?.city,
                    district: addressData?.district,
                    state: addressData?.state,
                    account_holder_name: bankData?.account_holder_name,
                    bank_name: bankData?.bank_name,
                    account_number: "'" + bankData?.account_number,
                    ifsc_code: bankData?.ifsc_code,
                    account_type: bankData?.account_type,
                    company_front_photo: filesUrl.dealership_front_pic,
                    company_back_photo: filesUrl?.dealership_back_pic,
                    company_left_photo: filesUrl?.dealership_left_side_pic,
                    company_right_photo: filesUrl?.dealership_right_side_pic,
                    dealer_pan_card_doc: filesUrl?.dealer_pan_card_doc,
                    dealer_gst_certificate_doc: filesUrl?.dealer_gst_certificate_doc,
                    dealer_principal_photo: filesUrl?.dealer_principal_profile_pic,
                    dealer_principal_KYC_doc: filesUrl?.dealer_principal_kyc_doc,
                    sales_person_KYC_doc: filesUrl?.sales_person_kyc_doc,
                    sales_person_photo: filesUrl?.sales_person_profile_pic,
                    Sales_person_educational_certificate_doc: filesUrl?.sales_person_education_doc,
                    cheque_doc: filesUrl?.cheque_doc,
                    MISP_agreement_doc: filesUrl?.misp_agreement_doc,
                    employee_id: personalData?.reference_id
                }
    
                const responseOfPersonalDetails = await insertMispProfileDetails(farmateMispDetails)
    
    
                if (responseOfPersonalDetails.status === 200){
                    // const jsonOfPersonalDetails = await responseOfPersonalDetails.json()
                    dispatch(setSuccessMessage('Company Registered Seccussfuly...'))
                    navigate('/company/')
    
                }else{
                    dispatch(setError('Something went wrong'))
                }
            }else{
                dispatch(setError('Documents Upload failed..'))
            }
 
        }catch(e){
            console.log(e , 'error')
            dispatch(setError('Internal Server Error'))
        }
        setIsLoaderTrue(false)
    }
 
    const clickNextBtn = (data) => {
 
        if (Object.keys(data).includes('channel_partner_name')) {
            setPersonalData((prv) => ({ ...prv, ...data }))
        } else if (Object.keys(data).includes('city')) {
            setAddressData((prv) => ({ ...prv, ...data }))
        } else {
            setBankData((prv) => ({ ...prv, ...data }))
        }
 
        // setUserDetails((prv) =>({...prv , ...data}))
        setCount((prv) => prv + 1)
    }
 
    const clickBackBtn = (data) => {
       
        if (Object.keys(data).includes('city')) {
            setAddressData((prv) => ({ ...prv, ...data }))
        } else if (Object.keys(data).includes('bank_name')) {
            setBankData((prv) => ({ ...prv, ...data }))
        } else {
            setDocumentsData((prv) => ({ ...prv, ...data }))
        }
        // if (dataOfDocuments !== undefined) {
        //     setDocumentsData(dataOfDocuments)
        // }
        setCount((prv) => prv - 1)
    }
 
 
    const displayComponents = () => {
        switch (count) {
            case 0:
                return <PersonalDetails clickNextBtn={clickNextBtn} personalData={personalData} />
            case 1:
                return <Address clickNextBtn={clickNextBtn} clickBackBtn={clickBackBtn} addressData={addressData} />
            case 2:
                return <BankDetails clickNextBtn={clickNextBtn} clickBackBtn={clickBackBtn} bankData={bankData} />
            default:
                return <Documents clickBackBtn={clickBackBtn} documentsData={documentsData} callPostApi={callPostApi} isLoaderTrue={isLoaderTrue}/>
        }
    }
 
 
 
    return (
        <Box sx={{ width: '100%', minHeight: '100dvh', backgroundColor: '#f0f2f5', display: "flex", justifyContent: 'center', alignItems: 'center' }}>
            <Container maxWidth={"md"} sx={{ padding: { xs: 0, sm: 'auto' } }}>
                <Paper sx={{ padding: '35px', borderRadius: '10px', minHeight: { xs: '100vh', sm: 'auto' }, }} elevation={3} >
                    <Typography variant="h3" style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: '30px' }}>Sign Up</Typography>
 
                    <Tabs
                        variant="scrollable"
                        scrollButtons="auto"
                        value={count} aria-label="basic tabs example" textColor="primary" indicatorColor="primary" sx={{
 
                            marginBottom: '25px',
 
                        }}>
                        <Tab label="Personal Details" />
                        <Tab label="Address" />
                        <Tab label="Bank Details" />
                        <Tab label="Documents" />
                    </Tabs>
 
                    {displayComponents()}
 
                </Paper>
            </Container>
           
        </Box>
    )
}
 
 
export default SignUp